import styled from "@emotion/styled";

import { theme } from "../../ThemeProvider/CandyTheme/ThemeShorthand";

export const Body = styled.div({
    width: 400,
});

export const RequisitesForm = styled.div({
    width: 400,
});

export const RequisitesFormLine = styled.div({
    marginBottom: 12,
});

export const Caption = styled.div(props => ({
    fontSize: theme(props).typography.smallFont.fontSize.css(),
    lineHeight: "16px",
    marginBottom: 4,
}));

export const Value = styled.div({});

export const Title = styled.div({
    marginBottom: 8,
});

export const Notes = styled.div({
    marginBottom: 8,
});

export const Warning = styled.span(props => ({
    color: theme(props).semanticColors.warning.color,
}));
